import { useEffect, useRef } from "react";
import $ from "jquery";
import "datatables.net";
import languageES from "datatables.net-plugins/i18n/es-MX";
import api from "@/api/api.js";
import i18n from "@/i18n.js";
import { ROLES } from "@/config/roles.js";

const ClientUsers = () => {
  const tableRef = useRef(null);
  const dataTable = useRef(null);

  useEffect(() => {
    dataTable.current = $(tableRef.current).DataTable({
      processing: true,
      serverSide: true,
      language: languageES,
      order: [[0, "asc"]],
      ajax: async (dtParams, callback) => {
        try {
          const response = await api.get("/users", {
            params: {
              page: dtParams.start / dtParams.length + 1,
              itemsPerPage: dtParams.length,
              search: dtParams.search?.value || undefined,
              role: ROLES.USER,
            },
          });
          callback({
            data: response.data["hydra:member"],
            recordsTotal: response.data["hydra:totalItems"],
            recordsFiltered: response.data["hydra:totalItems"],
          });
        } catch (error) {
          console.error("Error al cargar usuarios:", error);
          callback({ data: [] });
        }
      },
      columns: [
        {
          title: "Nombre",
          render: (data, type, row) =>
            `${row.userProfile?.name ?? ""} ${row.userProfile?.lastname ?? ""}`.trim() ||
            "—",
        },
        { title: "Email", data: "username" },
        {
          title: i18n.t("ui.issuers"),
          className: "text-center",
          render: (data, type, row) => row.companies?.length ?? 0,
        },
        {
          title: "Acciones",
          orderable: false,
          className: "text-nowrap",
          render: (data, type, row) => {
            const userId = row["@id"].split("/").pop();
            return `<a href="/client-users/${userId}/show" class="btn btn-outline-info btn-sm" title="Ver detalle">
                      <i class="bi bi-eye"></i> Ver detalle
                    </a>`;
          },
        },
      ],
    });

    return () => {
      if (dataTable.current) {
        dataTable.current.destroy();
      }
    };
  }, []);

  return (
    <div className="col">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title pb-3">Usuarios (clientes)</h5>
          <div className="table-responsive">
            <table
              ref={tableRef}
              className="display"
              style={{ width: "100%" }}
            ></table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientUsers;
